import { getLocales, Locale, useLocales } from 'expo-localization';

type SupportedLanguageCode = 'en' | 'es';

export const getSystemLocale = (): SupportedLanguageCode => {
  const locales = getLocales();
  return getPreferredSupportedLocale(locales);
};

export const useSystemLocale = (): SupportedLanguageCode => {
  const locales = useLocales();
  return getPreferredSupportedLocale(locales);
};

const getPreferredSupportedLocale = (locales: Locale[]): SupportedLanguageCode => {
  for (const locale of locales) {
    if (locale.languageCode === 'en' || locale.languageCode === 'es') {
      return locale.languageCode;
    }
  }
  return 'en';
};

export const getTransifexLocale = (locale: SupportedLanguageCode): string => {
  return locale === 'es' ? 'es_US' : 'en';
};
